import styled, { css } from "styled-components";

// ⚠️ Cores literais de propósito: os dois temas NÃO compartilham tokens — o
// common tem `neutral.cinza*`/`feedback.error` e o admin tem `neutral.gray*`/
// `feedbackState.critical`. Um componente usado nas duas áreas que lesse
// `theme.colors.feedback.error` sairia com `color: undefined` no admin, sem erro
// nenhum. O cinza é o mesmo nos dois; só o vermelho muda de tom para manter
// contraste no fundo escuro da área comum.
export const Counter = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  text-align: right;
  color: #989cac;

  ${({ variant, exceeded }) =>
    exceeded &&
    css`
      color: ${variant === "light" ? "#A81423" : "#FF6B6B"};
      font-weight: bold;
    `}
`;
